module.exports = __webpack_public_path__ + "static/img/home_sjgj.374613b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_sjgj.png
// module id = HROQ
// module chunks = 169